import { render, staticRenderFns } from "./HotPage.vue?vue&type=template&id=4df4b32c&scoped=true&"
import script from "./HotPage.vue?vue&type=script&lang=js&"
export * from "./HotPage.vue?vue&type=script&lang=js&"
import style0 from "./HotPage.vue?vue&type=style&index=0&id=4df4b32c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df4b32c",
  null
  
)

export default component.exports